import * as moment from 'moment';
import { auth, database } from '../firebase';

export const fetchFullCalendar = async details => {
	try{
		const allEvents = []
		const events = await database.collection("companies").doc(details.company).collection("calendar").get()
		if(!events.empty && events.size > 0){
			events.forEach((event) => {
				allEvents.push({title: event.data().title, description: event.data().description ? event.data().description:null, owner: event.data().owner, fullDate: event.data().fullDate, start: moment(event.data().start * 1000).toDate(), end: moment(event.data().end * 1000).toDate(), className: 'white', id: event.id})
			})
		}
		return Promise.all(allEvents).then((result) => {
			return {payload: result, error: null}
		})
	} catch(e) {
		throw new Error(e)
	}
}

export const addNewCalendarEvent = async event => {
	try{
		await database.collection("companies").doc(event.companyId).collection("calendar").add({end: event.end, start: event.start, owner: auth.currentUser.uid, title: event.title, description: event.description})
		return {error: null}
	} catch(e) {
		throw new Error(e)
	}
}


export const updateEvent = async eventInfo => {
	try{
		await database.collection("companies").doc(eventInfo.companyId).collection("calendar").doc(eventInfo.key).update({title: eventInfo.title, start: eventInfo.start, end: eventInfo.end})
		return {error: null}
	} catch(e) {
		throw new Error(e)
	}
}

export const deleteEvent = async details => {
	try{
		await database.collection("companies").doc(details.companyId).collection("calendar").doc(details.key).delete()
		return {error: null}
	} catch(e) {
		throw new Error(e)
	}
}

